export var SearchBarVariants;
(function (SearchBarVariants) {
    SearchBarVariants["primary"] = "primary";
    SearchBarVariants["secondary"] = "secondary";
})(SearchBarVariants || (SearchBarVariants = {}));
//# sourceMappingURL=constants.js.map